export default __webpack_public_path__ + "static/media/cartoon-1.faef5f72.svg";